import { render, staticRenderFns } from "./DeviceModelSelectBase.vue?vue&type=template&id=348a067f"
import script from "./DeviceModelSelectBase.vue?vue&type=script&lang=js"
export * from "./DeviceModelSelectBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports